module.exports = __webpack_public_path__ + "img/consult_info3.1879ea58.png";